import React, {Component} from 'react'
import "./EMR.css"
import SockJsClient from "react-stomp";
import RemotingService from "../../../services/remoting-service/RemotingService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Subjective from "./subjective/Subjective";
import Assessment from "./assessment/Assessment";
import {Treatment} from "./treatment/Treatment";
import Diagnosis from "./diagnosis/Diagnosis";
import Header from "./header/Header";
import NotificationService from "../../../services/notification-service/NotificationService";
import AuthService from "../../../services/auth-service/AuthService";
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import VisitHistory from "./visithistory/VisitHistory";
import Prescription from "./prescription/Prescription";
import MedicalReports from "./report/MedicalReports";
import EMRDashboard from "./dashboard/EMRDashboard";
import DateUtil from "../../../utils/DateUtil";
import EmrForms from "./visitforms/EmrForms";
import MissingDataChecker from "../home/header/MissingDataChecker";
import queryString from "query-string";
import Result from "./result/Result";
import EmrCheckPanel from "./emrcheck/EmrCheckPanel";
import RecommenderService from "../../../services/recommender-service/RecommenderService";

const DOCSTRIBE_ENABLED = process.env.REACT_APP_DOCSTRIBE_ENABLED === "true";
const DOCSTRIBE_BASE_URL = process.env.REACT_APP_DOCSTRIBE_BASE_URL;
const DOCSTRIBE_TOKEN = process.env.REACT_APP_DOCSTRIBE_TOKEN;
const DOCSTRIBE_TENANT_ID = process.env.REACT_APP_DOCSTRIBE_TENANT_ID;

export default class EMR extends Component {

    state = {
        queried: false,
        formFields: new Map(),
        disabled: false,
        copilotMinimized: false,
        showEmrCheck: false,
        // Once the drawer has been opened it stays mounted for the life of the record, so
        // closing it keeps the note and the reviewed parse instead of throwing them away.
        emrCheckMounted: false,
        emrCheckBadge: null,
        emrVersion: 0
    }

    componentDidMount() {
        if (AuthService.isAdminOrManager()) {
            this.setState({selectedTab: "visithistory"});
        }
        const {mode, patientid: patientId, appointmentid} = this.props.match.params;
        const urlParams = queryString.parse(this.props.location.search);

        const visitMode = mode === "visit";
        const url = `api/emr/${visitMode ? 'visit' : 'view'}/${patientId}/${appointmentid}/`;

        this.setState({disabled: !visitMode, selectedTab: this.state.selectedTab || urlParams.tab});

        const params = {
            id: appointmentid
        };

        RemotingService.getRemoteCall('api/appointment/retrieve', params, (appointment) => {
            this.setState({appointment: appointment});
        });

        RemotingService.postRemoteCall(url, null, (emr) => {
            const visitMetaData = emr.visits.map(v => ({
                id: v.id, type: v.appointmentType, date: v.appointment.startTime,
                provider: v.appointment?.staff?.name,
                diagnosis: v.diagnosis.diagnosisGroups?.flatMap(dg => dg.diagnosisItems?.map(item => item.description)).join(', '),
                diagnosisCode: v.diagnosis.diagnosisGroups?.flatMap(dg => dg.diagnosisItems?.map(item => item.code)).join(', '),
                department: v.appointment.staff.specialityName, location: v.clinic.name,
                status: (v.totalPoints - v.missingPoints) * 100 / v.totalPoints, legacyVisit: false
            }));

            const currentVisitIndex = emr.visits.findIndex(visit => visit.appointment.id == appointmentid);
            const currentVisit = emr.visits[currentVisitIndex]
            if (!!currentVisit && (currentVisit.missingPoints == null || currentVisit.totalPoints == null)) {
                const [missingPoints, totalPoints] = MissingDataChecker.getMissingPointsForVisit(currentVisit);
                currentVisit.missingPoints = missingPoints;
                currentVisit.totalPoints = totalPoints;
            }

            this.setState((state) => {
                return {
                    ...state,
                    emr: emr,
                    queried: true,
                    currentVisitIndex: currentVisitIndex,
                    currentVisit: currentVisit,
                    visitMetaData: visitMetaData
                };
            });

            this.refreshEmrCheckBadge(emr, currentVisit);
        })
    }

    // Cheap deterministic-only pass (no LLM call) just to size the badge on the button.
    // Fails open: if the recommender is unreachable the badge simply stays hidden.
    refreshEmrCheckBadge = (emr, currentVisit) => {
        if (!currentVisit || !AuthService.userHasAuthority("VIEW_EMR_DASHBOARD")) {
            return;
        }

        RecommenderService.analyze(
            {record: emr, visitId: currentVisit.id, semantic: false},
            (data) => this.setState({emrCheckBadge: (data.findings || []).length}),
            () => this.setState({emrCheckBadge: null})
        );
    }

    render() {
        if (this.state.queried == false || !this.state.appointment) {
            return (<div></div>);
        }

        const {emr, currentVisitIndex, currentVisit, appointment, disabled, formFields, visitMetaData} = this.state;
        const visits = emr.visits;
        const lastVisit = emr.visits.length > 0 ? emr.visits[emr.visits.length - 1] : null;
        const patientId = this.props.match.params.patientid;

        if (this.props.match.params.mode === "visit" && visits.length === 0) {
            NotificationService.showNotification({
                severity: 'error',
                summary: 'Start Visit Error',
                detail: 'The status of the appointment is not suitable for starting a new visit,' +
                    ' or it has been 24 hours since the appointment started.'
            });
        }

        const commonProps = {
            visits,
            currentVisit,
            currentVisitIndex,
            appointment,
            formFields,
            disabled,
            onModalSave: this.onModalSave,
            patientBirthday: emr.patient?.birthday
        };

        const {copilotMinimized} = this.state;
        const appointmentId = this.props.match.params.appointmentid;
        const copilotSrc = `${DOCSTRIBE_BASE_URL}/embed/cdi?patientId=${patientId}&appointmentId=${appointmentId}&token=${DOCSTRIBE_TOKEN}&tenantId=${DOCSTRIBE_TENANT_ID}&baseUrl=${DOCSTRIBE_BASE_URL}`;

        return (<div className={"emr-root"}>
            <div className="emr-header h-100 w-100 pl-4">
                <Header visit={currentVisit} appointment={appointment} patient={appointment.patient}/>
            </div>

            {DOCSTRIBE_ENABLED &&
                <div style={{
                    position: 'fixed',
                    bottom: 20,
                    right: 20,
                    width: copilotMinimized ? 240 : 600,
                    height: copilotMinimized ? 40 : 700,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
                    borderRadius: 8,
                    background: '#fff',
                    zIndex: 9999,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid #d0d7de'
                }}>
                    <div
                        style={{
                            padding: '8px 12px',
                            background: '#0d6efd',
                            color: '#fff',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            cursor: 'pointer',
                            userSelect: 'none',
                            fontWeight: 500
                        }}
                        onClick={() => this.setState({copilotMinimized: !copilotMinimized})}
                    >
                        <span>Docstribe Copilot</span>
                        <FontAwesomeIcon icon={["fas", copilotMinimized ? "chevron-up" : "chevron-down"]}/>
                    </div>
                    {!copilotMinimized && (
                        <iframe
                            src={copilotSrc}
                            title="Docstribe Copilot"
                            style={{flex: 1, width: '100%', border: 'none'}}
                        />
                    )}
                </div>
            }

            {visits.length === 0 &&
                <div className="no-visit-text">This is the patient's first visit</div>
            }
            {visits.length > 0 && !currentVisit &&
                <div className=" d-flex flex-column text-center">
                    <div className="no-visit-text">Visit not started.</div>
                    <a href="#" onClick={() => this.goToLastVisit()}>
                        Go to last visit
                        ({DateUtil.formatDateMMM(lastVisit.appointment.startTime)} / {DateUtil.getHourMinute12H(lastVisit.appointment.startTime)})
                    </a>
                </div>
            }
            {currentVisit &&
                <>
                    {DOCSTRIBE_ENABLED &&
                        <SockJsClient
                            url={RemotingService.getApiBaseUrl() + "websocket"}
                            topics={["/topic/visit/appointment/" + this.props.match.params.appointmentid]}
                            onMessage={() => this.componentDidMount()}
                            ref={client => this.clientRef = client}
                        />
                    }
                    <div className="pl-4">
                        <div className="w-100 mt-2 d-flex flex-row-reverse">
                            {!disabled && AuthService.userHasAuthority("VIEW_EMR_DASHBOARD") &&
                            <div className="d-flex justify-content-center" style={{width: "8%"}}>
                                <Button style={{width: 90}} variant="success"
                                        onClick={this.onModalSave}>
                                    <FontAwesomeIcon icon={["fas", "save"]}/>
                                    {'  Save '}
                                </Button>
                            </div>
                            }
                            {!disabled && AuthService.userHasAuthority("VIEW_EMR_DASHBOARD") && currentVisit.appointmentType == 'FOLLOW_UP' &&
                            <div className="d-flex justify-content-end" style={{width: "8%"}}>
                                <Button style={{minWidth: '160px'}} variant="success"
                                        onClick={this.convertFollowUpToNewComplaintPopUp}>
                                    <FontAwesomeIcon icon={["fas", "plus"]}/>
                                    <span className="ml-1">New Complaint</span>
                                </Button>
                            </div>
                            }
                        </div>
                    </div>

                    <div className="emr-content">
                        <div className="emr-form" key={this.state.emrVersion}>
                            <Tabs defaultActiveKey={AuthService.userHasAuthority("VIEW_EMR_DASHBOARD") ? 'dashboard' : 'visithistory'}
                                  id="emr-tabs"
                                  activeKey={this.state.selectedTab}
                                  onSelect={(key) => {
                                      this.setState({selectedTab: key})
                                  }}
                                  style={{marginLeft: 20, marginRight: 20, borderRadius: "10px"}}>
                                {AuthService.userHasAuthority("VIEW_EMR_DASHBOARD") &&
                                <Tab eventKey="dashboard" title="Dashboard">
                                    <EMRDashboard emr={emr} appointment={appointment}/>
                                </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_SUBJECTIVE") &&
                                <Tab eventKey="subjective" title="Subjective">
                                    <Subjective {...commonProps}
                                                subjective={currentVisit.subjective}
                                    />
                                </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_ASSESSMENT") &&
                                <Tab eventKey="assessment" title="Assessment">
                                    <Assessment {...commonProps}
                                                assessment={currentVisit.assessment}
                                                diagnosis={currentVisit.diagnosis}
                                    />
                                </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_DIAGNOSIS_BILLING") &&
                                <Tab eventKey="diagnosis" title="Diagnosis&Billing">
                                    <Diagnosis {...commonProps}
                                               diagnosis={currentVisit.diagnosis}
                                               insurance={emr.patient.insurance}
                                    />
                                </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_TREATMENT") &&
                                <Tab eventKey="treatment" title="Treatment">
                                    <Treatment {...commonProps}
                                               treatment={currentVisit.treatment}
                                               insurance={emr.patient.insurance}
                                    />
                                </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_PRESCRIPTION") &&
                                <Tab eventKey="prescription" title="Prescription">
                                    <Prescription {...commonProps}
                                                  subjective={currentVisit.subjective}
                                                  patientId={patientId}
                                    />
                                </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_RESULT") &&
                                    <Tab eventKey="result" title="Addendum & Results">
                                    <Result {...commonProps}
                                            treatment={currentVisit.treatment}
                                            emrId={emr.id}
                                            patientId={patientId}
                                            visitMetaData={visitMetaData}
                                            appointmentid={this.props.match.params.appointmentid}
                                    />
                                </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_VISIT_HISTORY") &&
                                    <Tab eventKey="visithistory" title="Visit History">
                                        <VisitHistory patient={emr.patient} visitMetaData={visitMetaData}
                                                      selected={this.state.selectedTab === "visithistory"}/>
                                    </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_REPORT") &&
                                    <Tab eventKey="report-generation" title="Reports">
                                        <MedicalReports emr={emr} appointment={appointment}
                                                        currentVisit={currentVisit} visitMetaData={visitMetaData}
                                                        currentVisitIndex={currentVisitIndex}/>
                                    </Tab>
                                }
                                {AuthService.userHasAuthority("VIEW_EMR_FORMS") &&
                                <Tab eventKey="consent-forms" title="Forms">
                                    <EmrForms {...commonProps} patientId={patientId}/>
                                </Tab>
                                }
                            </Tabs>
                        </div>
                        {/* The CoPilot entry point is a floating badge in the bottom-right corner rather
                            than a button in the save row: the save row scrolls away with the form, and
                            the drawer it opens is docked to the same corner of the screen. While the
                            drawer is open the badge stays put and turns into a close affordance -- a
                            second way out that is under the cursor, next to the drawer's own header X
                            rather than instead of it. It steps aside when the Docstribe widget occupies
                            that corner, but only while closed; open, it belongs on the drawer. */}
                        {!disabled && AuthService.userHasAuthority("VIEW_EMR_DASHBOARD") &&
                            <button type="button"
                                    className={"emr-copilot-fab" + (this.state.showEmrCheck ? " open" : "")}
                                    style={DOCSTRIBE_ENABLED && !this.state.showEmrCheck ? {right: 640} : undefined}
                                    title={this.state.showEmrCheck ? "Close EMR CoPilot" : "EMR CoPilot"}
                                    onClick={() => this.setState(s => ({
                                        showEmrCheck: !s.showEmrCheck,
                                        emrCheckMounted: true,
                                    }))}>
                                <span className="emr-copilot-fab-icon">
                                    <FontAwesomeIcon icon={["fas", this.state.showEmrCheck ? "times" : "magic"]}/>
                                </span>
                                {!this.state.showEmrCheck &&
                                    <span className="emr-copilot-fab-label">EMR CoPilot</span>}
                                {!this.state.showEmrCheck && this.state.emrCheckBadge > 0 &&
                                    <span className="emr-copilot-fab-badge">{this.state.emrCheckBadge}</span>}
                            </button>
                        }
                        {this.state.emrCheckMounted &&
                            <EmrCheckPanel emr={emr}
                                           currentVisit={currentVisit}
                                           hidden={!this.state.showEmrCheck}
                                           onClose={() => this.setState({showEmrCheck: false})}
                                           onApplied={this.onEmrCheckApplied}
                                           onNavigate={(tab) => this.setState({selectedTab: tab})}
                                           onSaveRequested={this.onModalSave}/>
                        }
                    </div>
                </>
            }
        </div>);
    }

    validateDiagnosisProcedures = (diagnosis) => {
        if (!diagnosis) return true;
        
        const hasProcedures = (diagnosis.directBillingProcedures && diagnosis.directBillingProcedures.length > 0) ||
                             (diagnosis.selfPayProcedures && diagnosis.selfPayProcedures.length > 0);
        
        return (!hasProcedures || this.hasAtLeastOnePrincipal(diagnosis)) &&
            this.validateDiagnosisLevelsAndTypes(diagnosis);
    }
    
    hasAtLeastOnePrincipal = (diagnosis) => {
        if (!diagnosis.diagnosisGroups) return false;
        
        return diagnosis.diagnosisGroups
            .filter(group => group && group.diagnosisItems && group.diagnosisItems.length > 0)
            .some(group => 
                group.diagnosisItems.some(item => 
                    item && item.level === 'PRINCIPAL'
                )
            );
    }

    validateDiagnosisLevelsAndTypes = (diagnosis) => {
        if (!diagnosis || !diagnosis.diagnosisGroups) return true;

        return diagnosis.diagnosisGroups.every(group =>
            !group || !group.diagnosisItems ? true :
                group.diagnosisItems.every(item => item && item.level != null && item.type != null)
        );
    }

    save = () => {
        const [url, params] = this.getUrlAndParamsForSave();
        RemotingService.postRemoteCall(url, params, (result) => {
            this.props.history.push('/emr');
        }, this.onSaveError);
    }

    // The check panel writes straight into currentVisit, but the form children captured
    // their slice of it in their constructors — bump the key to remount them.
    onEmrCheckApplied = () => {
        this.setState(state => ({
            emrVersion: state.emrVersion + 1,
            selectedTab: state.selectedTab
                || (AuthService.isAdminOrManager() ? 'visithistory' : 'dashboard')
        }));
    }

    onModalSave = (overrideProcedureTimestamps = false) => {
        if (!this.validateDiagnosisProcedures(this.state.currentVisit.diagnosis)) {
            NotificationService.showNotification({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'When procedures are added, at least one principal-level diagnosis is required, and every diagnosis must have a level and a type.'
            });
            return;
        }
        
        const [url, params] = this.getUrlAndParamsForSave(overrideProcedureTimestamps);
        RemotingService.postRemoteCall(url, params, (result) => {
            this.componentDidMount();

            if (DOCSTRIBE_ENABLED) {
                const {patientid: patientId, appointmentid: appointmentId} = this.props.match.params;
                fetch(`${DOCSTRIBE_BASE_URL}/api/disc/register`, {
                    method: 'POST',
                    headers: {
                        'X-API-Key': DOCSTRIBE_TOKEN,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({patientId, appointmentId})
                });
            }
        }, this.onSaveError);
    }

    getUrlAndParamsForSave = (overrideProcedureTimestamps = false) => {
        const url = 'api/emr/save/' + this.props.match.params.patientid
            + '/' + this.props.match.params.appointmentid;

        let [missingPoints, totalPoints] = MissingDataChecker.getMissingPointsForVisit(this.state.currentVisit);
        this.state.currentVisit.missingPoints = missingPoints;
        this.state.currentVisit.totalPoints = totalPoints;

        const params = {
            visit: this.state.currentVisit,
            emrVersion: this.state.emr.version,
            changedBy: AuthService.getUser().name,
            changedTime: DateUtil.now().toDate(),
            overrideProcedureTimestamps: overrideProcedureTimestamps === true
        }

        return [url, params];
    }

    onSaveError = (response) => {
        console.log(response);
        if (response.status !== 200) {
            NotificationService.showNotification({
                severity: 'error',
                summary: 'EMR Save failed.',
                detail: 'Please refresh the page or try again later.'
            });
        }
    }

    convertFollowUpToNewComplaintPopUp = () => {
        confirmDialog("New Complaint",
            "Are you sure this is a new complaint?",
            () => this.convertFollowUpToNewComplaint());
    }

    convertFollowUpToNewComplaint = () => {
        const url = 'api/emr/convert_follow_up_to_new_complaint/'
            + this.props.match.params.patientid
            + '/' + this.props.match.params.appointmentid;

        RemotingService.postRemoteCall(url, null, (result) => {
            window.location.reload(true);
        });
    }

    goToLastVisit() {
        const lastVisit = this.state.emr.visits[this.state.emr.visits.length - 1];

        RemotingService.getRemoteCall('api/appointment/retrieve', {id: lastVisit.appointment.id}, (appointment) => {
            window.history.replaceState(null, null, lastVisit.appointment.id); // Change browser url to the visit without reloading page
            this.setState((state) => {
                const currentVisitIndex = state.emr.visits.length - 1;
                return {
                    ...state,
                    appointment: appointment,
                    currentVisitIndex: currentVisitIndex,
                    currentVisit: lastVisit
                };
            });
        });
    }

}
